import { useQuery } from "react-query"
import { getTenantBudgetReportData } from "./api"

export const useTenantBudgetReportData = () => {
  return useQuery({
    queryKey: ['tenantBudgetReportData'],
    queryFn: getTenantBudgetReportData
  })
}
